import { KEY_APP_SURFACE_LABEL } from '../constants/index.ts';

// These attributes are exposed in the public API for users to use in the attributes scrubber
export const attributes = {
  pageLabel: KEY_APP_SURFACE_LABEL,
};
